
const SolutionsSection = () => {
  const solutions = [
    {
      number: '01',
      title: 'Formations Adaptées au Statut',
      description: 'Développez vos compétences avec des formations spécialement conçues pour les micro-entrepreneurs. Gestion, marketing, comptabilité, développement commercial : des programmes courts et pratiques qui s\'adaptent à votre emploi du temps et à votre budget.',
      benefits: [
        'Formations courtes et pratiques',
        'Tarifs préférentiels',
        'Certifications reconnues',
        'Accompagnement individuel',
      ],
      image: 'https://public.readdy.ai/ai/img_res/ff606c64f7d46fb36aa728e1ec4a7052.jpg',
    },
    {
      number: '02',
      title: 'Réseau Professionnel Local',
      description: 'Intégrez un réseau dynamique de professionnels de votre agglomération. Échangez avec d\'autres entrepreneurs, trouvez des partenaires, partagez des opportunités et bénéficiez d\'un soutien mutuel pour développer votre activité localement.',
      benefits: [
        'Événements networking réguliers',
        'Groupes d\'entraide',
        'Opportunités de partenariats',
        'Partage d\'expériences',
      ],
      image: 'https://readdy.ai/api/search-image?query=Professional%20networking%20event%20for%20micro-entrepreneurs%20in%20modern%20venue%2C%20diverse%20group%20of%20independent%20workers%20exchanging%20business%20cards%20and%20collaborating%2C%20friendly%20business%20meeting%20atmosphere%2C%20bright%20contemporary%20space%2C%20high%20quality%20business%20networking%20photography&width=800&height=600&seq=micro-reseau-001&orientation=landscape',
    },
    {
      number: '03',
      title: 'Externalisation Comptable & Administrative',
      description: 'Déléguez votre comptabilité et vos tâches administratives à des experts. Facturation, déclarations, suivi de trésorerie : concentrez-vous sur votre cœur de métier pendant que nous gérons vos obligations avec des tarifs adaptés aux micro-entrepreneurs.',
      benefits: [
        'Comptabilité externalisée',
        'Déclarations automatisées',
        'Suivi de trésorerie',
        'Conseil fiscal personnalisé',
      ],
      image: 'https://readdy.ai/api/search-image?query=Micro-entrepreneur%20using%20simple%20accounting%20software%20on%20laptop%20in%20home%20office%2C%20organized%20workspace%20with%20invoices%20and%20financial%20documents%2C%20clean%20modern%20desk%20setup%20showing%20efficient%20business%20management%2C%20natural%20lighting%2C%20high%20quality%20lifestyle%20business%20photography&width=800&height=600&seq=micro-compta-001&orientation=landscape',
    },
    {
      number: '04',
      title: 'Accompagnement au Développement',
      description: 'Bénéficiez d\'un accompagnement personnalisé pour structurer et développer votre activité. Stratégie commerciale, positionnement, tarification, prospection : un mentor dédié vous guide dans vos décisions pour assurer la pérennité de votre entreprise.',
      benefits: [
        'Mentorat personnalisé',
        'Plan de développement',
        'Aide à la prospection',
        'Suivi régulier',
      ],
      image: 'https://readdy.ai/api/search-image?query=Business%20mentor%20coaching%20micro-entrepreneur%20in%20modern%20cafe%20or%20coworking%20space%2C%20one-on-one%20consultation%20with%20laptop%20and%20notes%2C%20supportive%20professional%20guidance%20session%2C%20bright%20friendly%20atmosphere%2C%20high%20quality%20business%20coaching%20photography&width=800&height=600&seq=micro-accompagnement-001&orientation=landscape',
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-gray-light/5">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="text-center mb-12 md:mb-20">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-primary-dark mb-3 md:mb-4">
            Nos Solutions pour les Micro-entrepreneurs
          </h2>
          <p className="text-sm md:text-base lg:text-lg text-gray-dark max-w-2xl mx-auto">
            Des outils et un accompagnement adaptés à votre statut
          </p>
        </div>

        <div className="space-y-16 md:space-y-24">
          {solutions.map((solution, index) => (
            <div
              key={index}
              className={`grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center ${
                index % 2 === 1 ? 'lg:flex-row-reverse' : ''
              }`}
            >
              <div className={`${index % 2 === 1 ? 'lg:order-2' : ''}`}>
                <div className="relative">
                  <div className="absolute -top-6 -left-6 md:-top-8 md:-left-8 text-6xl md:text-8xl font-bold text-primary-light/20 select-none">
                    {solution.number}
                  </div>
                  <div className="relative space-y-4 md:space-y-6">
                    <h3 className="text-xl md:text-2xl lg:text-3xl font-bold text-primary-dark">
                      {solution.title}
                    </h3>
                    <p className="text-sm md:text-base lg:text-lg text-gray-dark leading-relaxed">
                      {solution.description}
                    </p>
                    <ul className="space-y-2 md:space-y-3">
                      {solution.benefits.map((benefit, idx) => (
                        <li key={idx} className="flex items-start gap-3">
                          <div className="w-5 h-5 md:w-6 md:h-6 flex items-center justify-center bg-primary rounded-full flex-shrink-0 mt-0.5">
                            <i className="ri-check-line text-white text-xs"></i>
                          </div>
                          <span className="text-sm md:text-base text-gray-dark">{benefit}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
              <div className={`${index % 2 === 1 ? 'lg:order-1' : ''}`}>
                <div className="rounded-2xl overflow-hidden shadow-xl">
                  <img
                    src={solution.image}
                    alt={solution.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SolutionsSection;
